import { render, staticRenderFns } from "./CategoriesOfRequestedDocumentsEmptyPage.vue?vue&type=template&id=6056a5e0&"
import script from "./CategoriesOfRequestedDocumentsEmptyPage.vue?vue&type=script&lang=js&"
export * from "./CategoriesOfRequestedDocumentsEmptyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports